<div class="py-2 px-4 bg-white max-w-md rounded-lg flex items-center gap-2">
	<h3 class="text-[16px] text-primary font-semibold flex-auto">
		{{ 'analysis.filters.label' | transloco }}
	</h3>

	<button
		class="flex-0"
		tuiIconButton
		size="s"
		appearance="ghost"
		(click)="onCopyLink()"
	>
		<tui-icon class="text-primary" icon="@tui.link" />
	</button>

	<button
		class="flex-0"
		tuiIconButton
		size="s"
		appearance="ghost"
		(click)="onOpenToggle()"
	>
		@if (open) {
			<tui-icon class="text-primary" icon="@tui.minus" />
		} @else {
			<tui-icon class="text-primary" icon="@tui.plus" />
		}
	</button>
</div>

@if (analysis(); as data) {
	@if (open && form) {
		<form
			tuiAnimated
			[formGroup]="form"
			class="px-4 h-14 mb-[6px] flex flex-row items-start gap-4 justify-start bg-white rounded-lg mt-[-10px] overflow-y-hidden overflow-x-auto [&>*]:mt-3"
		>
			@if ({ open: false }; as state) {
				<button
					tuiButton
					tuiChevron
					appearance="info"
					type="button"
					size="s"
					[class.ng-invalid]="form.get('segments')?.invalid"
					[tuiDropdown]="dropdownContent"
					[(tuiDropdownOpen)]="state.open"
					[class.disabled]="form.disabled"
				>
					@if (
						data.segments.length ===
						form.get('segments')?.value.length
					) {
						{{ 'analysis.filters.segments-all' | transloco }}
					} @else {
						{{
							'analysis.filters.segments-#'
								| transloco
									: {
											count: form.get('segments')?.value
												.length,
									  }
						}}
					}

					<ng-template #dropdownContent>
						<mar-multiselect-search
							[options]="data.segments"
							formControlName="segments"
						/>
					</ng-template>
				</button>
			}

			@if ({ open: false }; as financialState) {
				<button
					tuiButton
					tuiChevron
					appearance="info"
					type="button"
					size="s"
					[tuiDropdown]="financialDropdown"
					[(tuiDropdownOpen)]="financialState.open"
					[class.disabled]="form.disabled"
				>
					@if (form.get('financial')?.value; as financial) {
						{{ financial.label || financial.text | transloco }}
					}

					<ng-template #financialDropdown>
						<tui-data-list>
							@for (
								option of financialOptions;
								track option.value
							) {
								<button
									tuiOption
									type="button"
									(click)="
										onFinancialSelect(option);
										financialState.open = false
									"
								>
									{{
										option.label || option.text | transloco
									}}
								</button>
							}
						</tui-data-list>
					</ng-template>
				</button>
			}

			<hr class="border-none flex-1" />

			@if (this.loadingCalculation(); as data) {
				@if (data.erroredAt) {
					<div class="flex gap-2 items-center">
						<tui-icon
							class="text-red-500"
							size="s"
							icon="@tui.circle-alert"
						/>

						<div class="flex flex-col leading-snug text-left">
							<p>
								{{ 'generic.error-calculating' | transloco }}
							</p>
							<small class="font-bold">
								{{
									data.startedAt
										| relativeTime
											: {
													showNow: false,
													ago: false,
													exact: true,
											  }
								}}
							</small>
						</div>
					</div>

					<button
						size="s"
						tuiButton
						appearance="secondary"
						(click)="onClear()"
					>
						{{ 'action.clear' | transloco }}
					</button>

					<button size="s" tuiButton (click)="onRetry()">
						{{ 'action.retry' | transloco }}
					</button>
				} @else if (data.endedAt) {
					<div class="flex gap-2 items-center">
						<tui-icon
							class="text-green-500"
							size="s"
							icon="@tui.circle-check"
						/>

						<div class="flex flex-col leading-snug text-left">
							<p>
								{{ 'generic.calculation-ready' | transloco }}
							</p>
							<small class="font-bold">
								{{
									data.startedAt
										| relativeTime
											: {
													showNow: false,
													ago: false,
													exact: true,
											  }
								}}
							</small>
						</div>
					</div>

					<button size="s" tuiButton (click)="onLoad()">
						{{ 'action.load' | transloco }}
					</button>
				} @else if (data.startedAt) {
					<div class="flex gap-2 items-center h-8">
						<tui-loader size="s" />

						<div
							class="flex flex-col gap-1 leading-none flex-start w-36 text-left"
						>
							<p>{{ 'generic.calculating' | transloco }}</p>

							@if (loadingTime$ | async; as time) {
								<small class="font-bold">
									{{ time }}
								</small>
							}
						</div>
					</div>
				}
			} @else {
				<button
					size="s"
					tuiButton
					appearance="secondary"
					(click)="onReset()"
				>
					{{ 'action.reset' | transloco }}
				</button>

				<button
					size="s"
					tuiButton
					[disabled]="!valid()"
					(click)="onApply()"
				>
					{{ 'action.apply' | transloco }}
				</button>
			}
		</form>
	}
}
